export class EnquadradaDesenquadradaOutput {

    id: string;

    dataUltimoProcessamento: string;

    statusProcessamento: string;

    page;

}
